export default __webpack_public_path__ + "static/Logo6-317c2cf75a72f6ca643526e09b47274f.png";